<script lang="ts" setup>
// TODO провести рефакторинг
import './style.scss';

import type { UiDropdownProps } from './types';

const className = 'ui-dropdown';

const {
  visible,
  offset = 8,
  width = 300,
  position = 'right',
  styled = true,
  fullWidth = false,
  maxHeight,
} = defineProps<UiDropdownProps>();

const emit = defineEmits<{
  close: [];
}>();

const { y: windowY } = useWindowScroll();

const popup = ref();

const parentEl = useParentElement();

const { width: parentElWidth } = useElementBounding(parentEl);
const { width: currentElWidth } = useElementBounding(popup);

const elStyle = computed(() => {
  return `width: ${fullWidth ? parentElWidth.value : width}px; transform: translate(${position === 'right' ? parentElWidth.value - currentElWidth.value : 0}px, ${offset}px); max-height: ${maxHeight ? maxHeight + 'px' : 'unset'}; overflow: auto;`;
});

const onClose = () => {
  emit('close');
};

onClickOutside(popup, onClose);

watch(windowY, () => {
  if (windowY.value > 50) {
    onClose();
  }
});
</script>

<template>
  <div
    v-if="visible"
    ref="popup"
    :class="[className, { styled }]"
    :style="elStyle"
  >
    <div
      v-if="$slots.header"
      :class="`${className}__header`"
    >
      <slot name="header" />
    </div>
    <slot name="default" />
  </div>
</template>
